import styled from 'styled-components';
import { Alert } from 'antd';
import { useAuth } from 'hooks';

const StyledAlert = styled(Alert)`
  margin-bottom: ${p => p.theme.gutter};
`;

const PartnerNotice = () => {
  const { user } = useAuth();
  if (!user.isPartnerAccount) return null;
  return (
    <StyledAlert
      type='warning'
      showIcon
      message={
        <div>
          Note: Only contacts attending {user.userCompanyName} are available on
          this Organisation Profile. For access to complete Organisation
          Profiles, please&nbsp;
          <a
            href='https://scileads.com/get-started/'
            target='_blank'
            rel='noopener noreferrer'
          >
            Upgrade License
          </a>
        </div>
      }
    />
  );
};

export default PartnerNotice;
